export { AdminComponent } from "src/app/view/admin/admin.component";
export { AdminModule } from "src/app/view/admin/admin.module";
export { LoginComponent } from "src/app/view/login/login.component";
export { LoginModule } from "src/app/view/login/login.module";
